"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../app/contexts");
var _contexts2 = require("../box/contexts");
var _helpers = require("../box/helpers");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const usePaypal = alternativeAction => {
  const [active, setActive] = (0, _react.useState)(false);
  const {
    paypalId
  } = (0, _react.useContext)(_contexts.Settings);
  const onCtaBtnClick = paypalId ? e => {
    e.preventDefault();
    setActive(true);
  } : alternativeAction;
  const exit = (0, _react.useCallback)(() => setActive(false), []);
  const comp = active && /*#__PURE__*/_react.default.createElement(PaypalBtn, {
    alternativeAction: alternativeAction,
    paypalId: paypalId,
    exit: exit
  });
  return [comp, onCtaBtnClick];
};
var _default = usePaypal;
exports.default = _default;
function PaypalBtn(_ref) {
  let {
    alternativeAction,
    paypalId,
    exit
  } = _ref;
  const ref = (0, _react.useRef)();
  const {
    isMonthly,
    val
  } = (0, _react.useContext)(_contexts2.Amount);
  const {
    paypalReturnUrl,
    strings
  } = (0, _react.useContext)(_contexts.Settings);
  const {
    paypalMonthlyName,
    paypalSingleName,
    otherPaymentMethods
  } = strings;
  const amountStr = `${val}.00`;
  (0, _react.useEffect)(() => {
    if (!alternativeAction) {
      // submit immediately if no other payment methods specified
      ref.current.submit();
      setTimeout(exit, 1000);
    }
  }, [alternativeAction, exit]);
  const returnUrl = (0, _helpers.strOrFunc)(paypalReturnUrl, []) || location.href;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "donation-encourager__cta",
    hidden: !alternativeAction
  }, /*#__PURE__*/_react.default.createElement("form", {
    action: "https://www.paypal.com/cgi-bin/webscr",
    method: "post",
    target: "_blank" // _top
    ,

    ref: ref
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "business",
    value: paypalId
  }), isMonthly ? /*#__PURE__*/
  // <input type="hidden" name="cmd" value="_xclick-subscriptions" />
  _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "cmd",
    value: "_xclick-subscriptions"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "currency_code",
    value: "EUR"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "a3",
    value: amountStr
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "p3",
    value: "1"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "t3",
    value: "M"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "src",
    value: "1"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "item_name",
    value: paypalMonthlyName || ""
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "cmd",
    value: "_donations"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "amount",
    value: amountStr
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "item_name",
    value: paypalSingleName || ""
  })), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "return",
    value: returnUrl
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "donation-encourager__button donation-encourager__cta-button"
  }, "PayPal")), !!alternativeAction && /*#__PURE__*/_react.default.createElement("button", {
    onClick: alternativeAction,
    className: "donation-encourager__button donation-encourager__cta-button"
  }, otherPaymentMethods));
}